(function(){
  function init(root){
    const slides = Array.from(root.querySelectorAll('.rph__slide'));
    const tabs   = Array.from(root.querySelectorAll('.rph__tab'));
    const videos = Array.from(root.querySelectorAll('video'));

    if (!slides.length || !tabs.length) return;

    let activeId = root.dataset.active || slides[0].dataset.id;
    let sectionVisible = false;
    let sectionNear = false;
    let currentVideo = null;

    function isInViewport(el){
      const r = el.getBoundingClientRect();
      return r.top < window.innerHeight && r.bottom > 0;
    }

    function prepareVideos(){
      videos.forEach(v => {
        v.muted = true;
        v.loop = true;
        v.playsInline = true;
        v.preload = 'metadata';

        v.setAttribute('muted', '');
        v.setAttribute('loop', '');
        v.setAttribute('playsinline', '');
        v.setAttribute('preload', 'metadata');

        try {
          v.load();
        } catch(e) {}
      });
    }

    function pauseOtherVideos(activeVideo){
      videos.forEach(v => {
        if (v !== activeVideo) {
          try { v.pause(); } catch(e) {}
        }
      });
    }

    function getActiveVideo(){
      const activeSlide = slides.find(s => s.dataset.id === activeId);
      if (!activeSlide) return null;
      return activeSlide.querySelector('video');
    }

    function warmActiveVideo(){
      const video = getActiveVideo();
      if (!video) return;

      video.muted = true;
      video.loop = true;
      video.playsInline = true;

      video.setAttribute('muted', '');
      video.setAttribute('loop', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('preload', 'metadata');

      if (video.readyState < 2) {
        try { video.load(); } catch(e) {}
      }
    }

    function playActiveVideo(){
      const video = getActiveVideo();

      if (!video) {
        pauseOtherVideos(null);
        currentVideo = null;
        return;
      }

      pauseOtherVideos(video);

      if (!sectionVisible) {
        return;
      }

      if (currentVideo === video && !video.paused) return;

      currentVideo = video;

      video.play().catch(() => {});
    }

    function pauseAllVideos(){
      videos.forEach(v => {
        try { v.pause(); } catch(e) {}
      });
    }

    function setActive(id){
      if (!id) return;

      activeId = id;
      root.dataset.active = id;

      tabs.forEach(btn => {
        const isActive = btn.dataset.id === id;
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
        btn.tabIndex = isActive ? 0 : -1;
      });

      slides.forEach(s => {
        s.classList.toggle('is-active', s.dataset.id === id);
      });

      if (sectionNear) warmActiveVideo();
      playActiveVideo();
    }

    prepareVideos();

    tabs.forEach(btn => {
      btn.addEventListener('click', () => {
        const id = btn.dataset.id;
        const targetSel = btn.dataset.target;
        const target = targetSel ? root.querySelector(targetSel) : null;

        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }

        setActive(id);
      });
    });

    const nearObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        sectionNear = entry.isIntersecting;

        if (sectionNear) {
          warmActiveVideo();
        }
      });
    }, {
      root: null,
      threshold: 0,
      rootMargin: '500px 0px 500px 0px'
    });

    nearObserver.observe(root);

    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        sectionVisible = entry.isIntersecting || isInViewport(root);

        if (sectionVisible) {
          warmActiveVideo();
          playActiveVideo();
        } else {
          pauseAllVideos();
        }
      });
    }, {
      root: null,
      threshold: 0,
      rootMargin: '80px 0px 80px 0px'
    });

    sectionObserver.observe(root);

    const slideObserver = new IntersectionObserver((entries) => {
      const visible = entries
        .filter(e => e.isIntersecting)
        .sort((a,b) => b.intersectionRatio - a.intersectionRatio)[0];

      if (!visible) return;

      const newId = visible.target.dataset.id;

      if (newId !== activeId) {
        setActive(newId);
      }
    }, {
      root: null,
      threshold: [0.35, 0.6, 0.85],
      rootMargin: "-5% 0px -45% 0px"
    });

    slides.forEach(slide => slideObserver.observe(slide));

    sectionNear = true;
    sectionVisible = isInViewport(root);

    setActive(activeId);

    if (sectionVisible) {
      playActiveVideo();
    }
  }

  function boot(){
    document.querySelectorAll('.rph[data-section-id]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();